/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Show_PromptInputs */

const en_console_show_prompt = /** @type {(inputs: Console_Show_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show prompt`)
};

const zh_hans1_console_show_prompt = /** @type {(inputs: Console_Show_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示提示词`)
};

const pt_br2_console_show_prompt = /** @type {(inputs: Console_Show_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar prompt`)
};

const es_console_show_prompt = /** @type {(inputs: Console_Show_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar prompt`)
};

const fr_console_show_prompt = /** @type {(inputs: Console_Show_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le prompt`)
};

const de_console_show_prompt = /** @type {(inputs: Console_Show_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt anzeigen`)
};

const ru_console_show_prompt = /** @type {(inputs: Console_Show_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать промпт`)
};

const it_console_show_prompt = /** @type {(inputs: Console_Show_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra prompt`)
};

/**
* | output |
* | --- |
* | "Show prompt" |
*
* @param {Console_Show_PromptInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_show_prompt = /** @type {((inputs?: Console_Show_PromptInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Show_PromptInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_show_prompt(inputs)
	if (locale === "pt-BR") return pt_br2_console_show_prompt(inputs)
	if (locale === "es") return es_console_show_prompt(inputs)
	if (locale === "fr") return fr_console_show_prompt(inputs)
	if (locale === "de") return de_console_show_prompt(inputs)
	if (locale === "ru") return ru_console_show_prompt(inputs)
	if (locale === "it") return it_console_show_prompt(inputs)
	return en_console_show_prompt(inputs)
});